import CheckCircleIcon from '@material-ui/icons/CheckCircleOutline';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import { WarningOutlined } from '@material-ui/icons';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';

const GRAVITY_CONFIG = {
  warning: {
    backgroundColor: '#FFF8E1',
    borderColor: '#FDD835',
    icon: <WarningOutlined style={{ fontSize: 22, color: '#F9A825' }} />,
  },
  info: {
    backgroundColor: '#E3F2FD',
    borderColor: '#64B5F6',
    icon: <InfoIcon style={{ fontSize: 22, color: '#1976D2' }} />,
  },
  success: {
    backgroundColor: '#E8F5E9',
    borderColor: '#81C784',
    icon: <CheckCircleIcon style={{ fontSize: 22, color: '#388E3C' }} />,
  },
  error: {
    backgroundColor: '#FFEBEE',
    borderColor: '#E57373',
    icon: <ErrorIcon style={{ fontSize: 22, color: '#E57373' }} />,
  },
};

const styles = {
  container: {
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
    padding: 16,
    marginTop: 10,
    marginBottom: 10,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  title: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#3f3f3f',
    marginLeft: 10,
    marginBottom: 0,
    marginTop: 0,
  },
  subtitle: {
    fontSize: 14,
    color: '#5f5f5f',
    marginTop: 10,
    marginBottom: 0,
  },
  divider: {
    height: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    marginTop: 12,
    marginBottom: 12,
  },
  body: {
    marginTop: 0,
  },
};

class InfoSection extends React.Component {
  render() {
    const { title, subtitle, body, hideIcon, gravity = 'info', containerStyle, headerStyle, titleStyle, subtitleStyle } = this.props;
    const config = GRAVITY_CONFIG[gravity] || GRAVITY_CONFIG.info;

    return (
      <div
        style={{
          ...styles.container,
          backgroundColor: config.backgroundColor,
          borderLeftColor: config.borderColor,
          ...containerStyle,
        }}
      >
        <div style={{...styles.header, ...headerStyle}}>
          {!hideIcon ? config.icon : null}
          {title && <h4 style={{...styles.title, ...titleStyle}}>{_.isString(title) ? <Entity entity={title} /> : title}</h4>}
        </div>
        {subtitle && <h5 style={{...styles.subtitle, ...subtitleStyle}}>{_.isString(subtitle) ? <Entity entity={subtitle} /> : subtitle}</h5>}
        {body && (
          <>
            <div style={styles.divider} />
            <div style={styles.body}>{body}</div>
          </>
        )}
      </div>
    );
  }
}

export default InfoSection;

